export default __webpack_public_path__ + "static/media/watch.cbef685f.jpg";